require("./request-a-quote.js");
require("./gallery.js");
require("./reviews.js");
require("./home.scss");